export default {
	qrcode: true
};